import React from "react";

import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import GreenTick from "../../assets/green-tick.svg";
import WhiteTick from "../../assets/white-tick.svg";
import { setLoading, setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile, dashboard } from "../../redux/thunk/app.thunk";
import config from "../../config";
import {
  openAccountOpenWait,
  openKycFail,
  openAccountOpenSuccess,
} from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";
import { AccountStatus, DashboardAction } from "../../utilities/Variables";
const publicIp = require("public-ip");

const Disclosures = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const [isLinkOpened, setLinkOpened] = React.useState(false);
  const [isTicked, setTicked] = React.useState(false);

  const onSubmit = () => {
    if (isTicked) {
      publicIp.v4().then((response) => {
        dispatch(
          updateUserProfile({
            authStatement: utils.DISCLOSURES_BOTTOM_HEADING,
            fingerprint: response,
          })
        ).then(() => {
          dispatch(dashboard({ action: DashboardAction.CreateAccount })).then(
            (response) => {
              const accountStatus = response?.account_status;
              if (accountStatus === AccountStatus.KycPeding) {
                dispatch(setUserCurrentScreen(config.routes.accountOpenWait));
                openAccountOpenWait();
              } else if (accountStatus === AccountStatus.KycFail) {
                dispatch(setUserCurrentScreen(config.routes.kycFail));
                openKycFail();
              } else if (accountStatus === AccountStatus.AccountOpened) {
                dispatch(
                  setUserCurrentScreen(config.routes.accountOpenSuccess)
                );
                openAccountOpenSuccess();
              }
            }
          );
        });
      });
    }
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.DISCLOSURES_HEADER}</h2>
        {utils.DISCLOSURES_SUBHEADINGS.map((subheading, index) => {
          return <p className={classes.SubHeading}>{subheading}</p>;
        })}
      </div>
      <div className={classes.middle}>
        {utils.LINK_ITEMS.map((item) => {
          return (
            <a
              href={item.value}
              style={{ margin: "8px 0", color: "#17c95f" }}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                item.label === "Alpaca Customer Agreement" &&
                  setLinkOpened(true);
              }}
            >
              {item.label}
            </a>
          );
        })}
        <p className={classes.SubHeading} style={{ fontWeight: "bold" }}>
          {utils.DISCLOSURES_MESSAGE}
        </p>
      </div>
      <div
        className={classes.middlebottom}
        onClick={() => isLinkOpened && setTicked(!isTicked)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            margin: "10px 0",
            alignItems: "flex-start",
          }}
        >
          <img
            src={isTicked ? GreenTick : WhiteTick}
            alt="green-tick"
            style={{ margin: "5px 5px 5px 0" }}
          />
          {utils.DISCLOSURES_BOTTOM_HEADING}
        </div>
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={isTicked ? "active" : "disabled"}
          action={onSubmit}
        >
          {utils.DISCLOSURES_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default Disclosures;
